import * as React from 'react'
import { Block } from '../Layout/Block'
import { Icon, IconSizeName } from '../Icon'
import { styled } from '$utils/theme'
import { Text } from '../Text'
import { TextFontWeight } from '$utils/theme/font'
import { VerticalMarginProps, HorizontalMarginProps } from '$utils/theme/css'
import { Link } from '$views/components/Link'

interface Props {
  className?: string
  label: string
  urlIcon: string
  size?: IconSizeName
  weight?: TextFontWeight
  color?: string
  resize?: {
    height: any
    width: any
  }
  downloadFile?: () => void
  boldLabel?: string
  clickable?: boolean
  onClick?: any
  alignItems?: 'center' | 'start' | 'end' | 'baseline'
}
const MediaBlock = styled(Block)`
  width: 100%;
`
const MediaText = styled(Text)`
  flex-grow: 1;
  display: inline-flex;
  font-weight: ${p => (p.weight ? p.theme.fontWeight[p.weight] : p.theme.fontWeight.medium)};
`

export const Media: React.SFC<Props & HorizontalMarginProps & VerticalMarginProps> = ({
  label,
  urlIcon,
  onClick,
  downloadFile,
  boldLabel,
  ...props
}) => {
  return (
    <MediaBlock flex {...props}>
      {downloadFile ? (
        <Link onClick={() => downloadFile()} download="filename">
          {label}
        </Link>
      ) : (
        <MediaBlock>
          {boldLabel && (
            <MediaText marginRight="tiny" color={props.color}>
              {boldLabel}
            </MediaText>
          )}
          <MediaText weight={props.weight} color={props.color}>
            {label}
          </MediaText>
        </MediaBlock>
      )}
      <Icon
        content={urlIcon}
        size={props.size}
        resize={props.resize}
        color={props.color}
        clickable={props.clickable}
        onClick={onClick}
        {...props}
      />
    </MediaBlock>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Media/Media.tsx